import { DATA_ANALYST } from './apis'
import axios from '@/assets/js/axios.js'
export function taskLogList (params) {
  return axios({
    url: DATA_ANALYST.DATA_ANALYST_TASK_LOG_LIST,
    method: 'post',
    data: params
  })
}
export function taskList (params) {
  return axios({
    url: DATA_ANALYST.DATA_ANALYST_TASK_LIST,
    method: 'post',
    data: params
  })
}
// 任务调度列表接口
export function timeLogList (params) {
  return axios({
    url: DATA_ANALYST.DATA_ANALYST_TIMER_LOG_LIST,
    method: 'post',
    data: params
  })
}
